export const constants = {
  SHOW_MODAL: 'SHOW_MODAL',
};
